import { render, staticRenderFns } from "./ItemPickerPopover.vue?vue&type=template&id=0510ca36&"
import script from "./ItemPickerPopover.vue?vue&type=script&lang=js&"
export * from "./ItemPickerPopover.vue?vue&type=script&lang=js&"
import style0 from "./ItemPickerPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports